import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BroadcastMessageType } from '../models/broadcast-message-type.model';

@Injectable({
  providedIn: 'root',
})
export class BroadcastMessageTypeService {
  constructor(private http: HttpClient) {}

  findById(id: number) {
    return this.http.get<BroadcastMessageType>(`broadcast-message-types/${id}`);
  }

  findAll() {
    return this.http.get<BroadcastMessageType[]>('broadcast-message-types');
  }
}
